module.exports = __webpack_public_path__ + "img/folder.e99945bc.svg";